<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formConcept">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="conceptContract.userNameCreate"
              [createDate]="conceptContract.createDate" [userNameUpdate]="conceptContract.userNameUpdate"
              [updateDate]="conceptContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="typeConceptId" [labelText]="'Tipo Concepto'" [required]="true"
                [recovery]="true" [list]="listTypeConcepts" (onChangeSelect)="changeTypeConcept($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeConcept($event)"></app-custom-input-number>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12">
              <app-custom-input-text formControlName="alterCode2" [labelText]="'Cód. Alterno 2'"
                [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-8 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true"
                [maxLength]="70"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-1">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                [variant]="undefined" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>